export default class Localization {

    private messages : { [key : string] : string } = typeof window !== 'undefined' ? (window.jsI18n || []) : {};

    /**
     * Note: The currently used message keys can be found in `lang/hu/javascript.php`.
     *
     * Usage examples:
     *
     * 1) Returns a simple translated text:
     * Use the following method to retrieve a translation:
     * Localization().getMessage('valid_message_key');
     *
     * 2) Returns a translated text with dynamic values:
     * If you need to include dynamic values,
     * define a message in the `javascript.php` localization file like this:
     * 'valid_message_key' => 'Adults {adult}, Children {children}',
     *
     * Then, in your frontend code,
     * pass an object where the keys correspond to the dynamic variables
     * and the values represent what you want to display:
     * Localization().getMessage('valid_message_key', {adult: 2, children: 3});
     *
     * @param {string} messageKey - The key for the message to retrieve.
     * @param {Object} [params] - An optional object containing dynamic values for the message.
     */
    public getMessage(messageKey : string, params ?: { [key : string] : string }) : string {
        const message = this.messages[messageKey];

        if (typeof params === 'undefined') {
            return message;
        }
        return this.replaceParamsInMessage(message, params);
    }

    // eslint-disable-next-line max-len
    private replaceParamsInMessage(message : string, params : { [key : string] : string }) : string {
        const placeholderRegex = /{(.*?)}/gm;
        const foundPlaceholders = (
            message.match(placeholderRegex)
            || []
        );

        foundPlaceholders
        .forEach(
            (placeholder) => {
                const trimPlaceholder = placeholder
                .replace('{', '')
                .replace('}', '')
                .trim();

                if (trimPlaceholder in params) {
                    message = message.replace(
                        placeholder,
                        params[trimPlaceholder],
                    );
                }
            },
        );
        return message;
    }

}
